import { Box, Container, Grid, Typography } from "@mui/material";
import { lines1 } from "../../assets";


const items = [
  {
    title: "Channel Partner Networks",
    desc: "Structured and activated for consistent deal movement",
  },
  {
    title: "Broker Ecosystem Activation",
    desc: "Aligned, engaged, and performance-driven",
  },
  {
    title: "Investor Connections",
    desc: "Access to high-value capital and decision-makers",
  },
  {
    title: "Marketing & Execution Partners",
    desc: "Integrated support for seamless sales execution",
  },

];

const StrategicAlliances = () => {
  return (
    <Box
      sx={{
        position: "relative",
        background: `
          linear-gradient(
            135deg,
            #0f63a5 0%,
            #0c4f85 60%,
            #083a63 100%
          )
        `,
        py: { xs: 10, md: 8 },
        overflow: "hidden",
      }}
    >

   
      {/* 🔥 GLOW BACKGROUND */}
      <Box
        sx={{
          position: "absolute",
          width: "600px",
          height: "600px",
          top: "-150px",
          left: "-150px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.15), transparent 70%)",
          filter: "blur(100px)",
        }}
      />

      <Container maxWidth="lg">

        {/* HEADER */}
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography
          variant="h4"
            sx={{
              
              fontSize: { xs: 30, md: 42 },
              fontWeight: 600,
              color: "#ffffff",
              mb: 3,
              letterSpacing: "0.5px",
              
            }}
          >
            Strategic Alliances & Ecosystem
          </Typography>

          <Typography
          variant="body2"
            sx={{
              fontSize: 18,
              color: "rgba(255,255,255,0.8)",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            A connected network that amplifies reach, strengthens conversions, and accelerates deal flow
          </Typography>
        </Box>

        <Grid container spacing={8} alignItems="center">

          {/* LEFT CONTENT */}
          <Grid item xs={12} md={6}>
            {items.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  gap: 3,
                  mb: 4,
                  position: "relative",
                  textAlign:'start'
                }}
              >
                {/* 🔥 GLOW LINE */}
                <Box
                  sx={{
                    width: "4px",
                    height: "60px",
                    borderRadius: "4px",
                    background: "linear-gradient(#ffffff, #cfe8ff)",
                    boxShadow: "0 0 12px rgba(255,255,255,0.6)",
                    mt: "2px",
                  }}
                />

                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Playfair Display",
                      fontSize: 22,
                      fontWeight: 600,
                      color: "#ffffff",
                      mb: 1,
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                  variant="body2"
                    sx={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: 15,
                      lineHeight: 1.7,
                      maxWidth: "420px",
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Grid>

          {/* RIGHT IMAGE */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: "relative",
                borderRadius: "24px",
                overflow: "hidden",

                // 🔥 IMAGE SHADOW DEPTH
                boxShadow: `
                  0 30px 80px rgba(0,0,0,0.4),
                  0 10px 30px rgba(0,0,0,0.3)
                `,
              }}
            >
              {/* IMAGE */}
              <Box
                component="img"
                // src="https://dprstorage.b-cdn.net/RW/leadgen/charminar-hyderabad.webp"
                src="https://dprstorage.b-cdn.net/RW/leadgen/Alliances3.png"
                sx={{
                  width: "100%",
                  display: "block",
                }}
              />

              {/* 🔥 GLASS OVERLAY */}
              {/* <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(15,99,165,0.25)",
                  backdropFilter: "blur(4px)",
                }}
              /> */}

              {/* 🔥 GLOSS LIGHT */}
              {/* <Box
                sx={{
                  position: "absolute",
                  top: "-30%",
                  left: "-20%",
                  width: "150%",
                  height: "150%",
                  background:
                    "radial-gradient(circle, rgba(255,255,255,0.25), transparent 70%)",
                }}
              /> */}
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default StrategicAlliances;